var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoupleSittingYellowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  viewBox: "0 0 692.68 534.44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M215.22 295.99c2.93-3.93 4.87-8.5 5.67-13.33l32.6-39.48-19.24-14.96-31 41.66a30.6 30.6 0 0 0-10.9 9.54c-7.19 9.92-7.91 21.68-1.59 26.25 6.31 4.58 17.26.24 24.45-9.68z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m347.26 139.3-40.78-27.25-82.76 125.92 21.55 23.13z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M0 292.56c0 .87.7 1.57 1.57 1.57h689.54c.87 0 1.57-.7 1.57-1.57s-.7-1.57-1.57-1.57H1.57c-.87 0-1.57.7-1.57 1.57"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m277.66 104.05-4.55-31.35 40.18-10.22 5.34 27.74zM156.47 439.91l4.77 44.5 32.84-10.07-5.3-35.49z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M272.48 246.55s-107.54 20.66-120.25 51.92 2.12 148.33 2.12 148.33l36.55 3.71 15.36-134.56s93.24-1.59 100.12-12.71 5.83-51.39 5.83-51.39zM156.9 462.52l-21.3 21.16s-36.35 29.86-13.04 28.27 83.7-15.89 83.17-27.02-10.07-33.37-10.07-33.37l-38.77 10.95h.01Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m280.97 452.73 24.02 37.76 24.97-23.59-20.5-29.46z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M299.13 227.97s-87.2 66.24-84.73 99.89c2.48 33.65 67.72 131.98 67.72 131.98l34.4-12.9-45.94-127.4s82.85-42.8 84.08-55.82-17.58-48.63-17.58-48.63l-37.96 12.88zM292.1 470.29l-12.13 32.27s-17.59 41.55 2.59 29.78 67.95-51.38 62.54-61.12-23.83-25.44-23.83-25.44z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 291.74,
  cy: 49.82,
  r: 32.7,
  fill: "#ffb6b6"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m315.92 74.92-40.79 30.2-6.36 131.38-15.36 14.83 52.97 51.92s58.27-18.01 52.44-45.56l-5.83-27.55 2.1-30.74A178.85 178.85 0 0 0 315.9 74.93h.02Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m315.26 75.6-19.9-.66s5.16-31.18-7.14-31.01l-11.12-5.29s-27.81-18.74-15.06-26.6C274.8 4.19 283.7-2.87 290.99 1.18c7.3 4.05 22.08 5.63 22.08 5.63s26.22 11.04 25.44 20.27-6.74 49.66-23.26 48.51h.01Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M228.46 298.1c2.73-4.07 4.45-8.73 5.01-13.59l30.62-41.03-19.95-14-28.91 43.13c-4.23 2.47-7.8 5.93-10.42 10.06-6.7 10.27-6.83 22.04-.3 26.3s17.25-.61 23.95-10.87"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m352.62 135.1-42.06-25.21-76.47 129.85 22.66 22.03z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m566.48 329.07 8.98 86-34.24 2.75-1.96-83.47z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m575.87 396.1 27.6 11.82s44.8 14.35 22.55 21.47-83.66 16.1-87.27 5.56-2.95-34.73-2.95-34.73l40.07-4.11ZM428.4 219.17l14.23 6.82s104.58-5.87 111.68 13.53c7.1 19.41 20.83 135.37 20.83 135.37l-36.92 2.37-16.09-78.57-93.72-79.52z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M527.45 242.63a30.7 30.7 0 0 0-12.47-7.38l-34.84-37.51-17.37 17.1 37.21 36.21c1.67 4.6 4.42 8.74 8.02 12.06 8.89 8.44 20.45 10.69 25.82 5.04s2.52-17.08-6.37-25.51Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m389.52 91.12-32.39 36.83 113.94 98.62 25.76-18.31z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m514.38 327.31-55.14 66.6-25.94-22.52 58.25-59.83z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m472.08 375.66 10.88 27.98s21.11 42.04.45 31.13-70.05-48.48-65.06-58.44 22.74-26.42 22.74-26.42l30.99 25.74ZM365.93 246.15s-20.83 49.22 13.25 49.22 114.07-2.84 114.07-2.84l-23.67 41.65 27.93 14.2s58.69-55.38 54.9-80.46-109.78-41.93-109.78-41.93l-21.41 5.63zM363.11 11.12s36.74 1.95 40.03 16.05c3.29 14.09-4.24 28.48 7.58 28.33s15.95 5.11 15.95 5.11-12.06 34.15-31 36.11-32.56-85.6-32.56-85.6"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "m387.75 105.3 1.14-31.66-41.05-5.82-2.32 28.15z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M398.9 42.53c5.73 17.12-3.51 35.65-20.63 41.38s-35.65-3.51-41.38-20.63 3.51-35.65 20.63-41.38 35.65 3.51 41.38 20.63"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m393.31 92.9-37.58-7.83-7 62.78c-1.79 6.96 1.67 33.4 3.51 40.34l11.32 76.15 79.07-38.36-18.01-44.62 3.91-32.1L393.3 92.9z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb6b6",
  d: "M411.17 177.1c-4.8 1-9.28 3.13-13.09 6.22l-50.58 7.94 4.48 23.96 50.82-10.64a30.8 30.8 0 0 0 14.48.09c11.97-2.66 20.29-10.99 18.6-18.6s-12.76-11.63-24.72-8.97Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffbd01",
  d: "m381.28 132.5-33.93-29.03-50.06 87.79c-1.48 20.46 17.19 36.56 37.21 32.07l44.9-10.95-8.57-36.13-25.24-.93 35.71-42.83h-.02Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M342.74 17.46s-40.24 11.09-31.11 27.03 19.85 20.42 18.52 29.42 9.26 43.91 25.37 38.52 40.16-15.71 40.16-15.71-33.96-28.53-27.98-33.37-12.89-39-12.89-39 19.15-9.26 29.3-6.48 15.81 1.84 15.81 1.84-27.65-25.89-39.94-15.6-17.23 13.36-17.23 13.36v-.01Z"
})));
export default SvgCoupleSittingYellowIcon;